import {NgModule, Optional, SkipSelf} from "@angular/core";
import { CommonModule } from "@angular/common";
import { ErrorHandlerModule } from "./errors/error-handler.module";
import {EnsureModuleLoadedOnceGuard} from "./ensure-module-loaded-once.guard";
import {GroupGuardService} from "./guards/group-guard.service";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {RedirectGuardService} from "./guards/redirect-guard.service";
import {AuthService} from "./auth/auth.service";
import {TokenInterceptor} from "./auth/token.interceptor";
import {OnboardGuardService} from "./guards/onboard-guard.service";
import { TextResponseInterceptor } from "./interceptors/text-response.interceptor";

const interceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
  { provide: HTTP_INTERCEPTORS, useClass: TextResponseInterceptor, multi: true}
];
@NgModule({
  imports: [CommonModule, ErrorHandlerModule],
  providers: [
    OnboardGuardService,
    GroupGuardService,
    RedirectGuardService,
    AuthService,
    interceptorProviders
  ],
})

export class CoreModule extends EnsureModuleLoadedOnceGuard {    // Ensure that CoreModule is only loaded into AppModule

  // Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    super(parentModule);
  }
}
